'use client'

import { setLocalDevice, setLocalRegister } from '@/lib/actions'
import { cn } from '@/lib/utils'
import { motion } from 'framer-motion'
import { useRouter } from 'next/navigation'
import React from 'react'
import { toast } from 'sonner'

import { AvatarCard, AvatarCardSkeleton } from '@/components/ui/avatar-card'

interface DeviceCardListProps extends React.ComponentPropsWithoutRef<'div'> {
  list: any[]
}

const variants = {
  animate: {
    opacity: 1,
    marginTop: 0,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

export const DeviceCardList = ({ list, className }: DeviceCardListProps) => {
  const router = useRouter()
  const [isLoading, setIsLoading] = React.useState(false)

  return (
    <motion.div
      variants={variants}
      animate="animate"
      className={cn('p-1', className)}
    >
      {(list || [])?.map((device) => {
        return (
          <AvatarCard
            actionLabel="Select"
            className="mt-2 cursor-pointer opacity-0"
            key={device?.id}
            label={device?.device_name}
            shortCode={device?.device_name?.substring(0, 2)}
            variants={variants}
            isLoading={isLoading === device?.id}
            disabled={isLoading}
            onClick={async () => {
              setIsLoading(device?.id)
              await setLocalRegister(device['pos-register']?.id)
              await setLocalDevice(
                device?.id,
                device?.printer_type,
                device?.document_type,
                device?.settings?.virtual_keyboard === 'on',
                device?.settings?.payment_confirmation === 'on',
                device?.kot_printer_type,
              )
              localStorage?.setItem(
                'showVirtualKeyboard',
                device?.settings?.virtual_keyboard === 'on' ? 'true' : 'false',
              )
              localStorage?.setItem(
                'previewAdType',
                device?.ad?.type ?? 'placeholder',
              )
              localStorage?.setItem(
                'previewAdUrl',
                device?.ad?.url ?? 'placeholder',
              )
              localStorage?.setItem(
                'showPaymentConfirmation',
                device?.settings?.payment_confirmation === 'on'
                  ? 'true'
                  : 'false',
              )
              router.push(`/onboard/${device?.location_id}/${device?.id}`)
            }}
          />
        )
      })}
    </motion.div>
  )
}

export const DeviceCardListSkeleton = () => {
  return (
    <motion.div
      variants={variants}
      animate="animate"
      className="flex w-full flex-col gap-2 py-8 opacity-100 md:px-4"
    >
      <AvatarCardSkeleton variants={variants} className="opacity-100" />
      <AvatarCardSkeleton variants={variants} className="opacity-100" />
      <AvatarCardSkeleton variants={variants} className="opacity-100" />
    </motion.div>
  )
}
